import { render, staticRenderFns } from "./url-setting-modal.vue?vue&type=template&id=24c00fd0&"
import script from "./url-setting-modal.vue?vue&type=script&lang=js&"
export * from "./url-setting-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports